import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';

import { NODE_ENV } from 'Settings';
import { initSentry } from 'Utils/errorTracking';
import ErrorBoundary from 'Containers/ErrorBoundary';
import configureStore from './store/configureStore';
import Routes from './RoutesV2';
import styles from './styles/index.scss';

// Initialize Google Analytics tracking
ReactGA.initialize('UA-34697160-8', {
  // The debug is _preetttty_ noisy, so it is off by default
  // even though we used to have it on in dev.
  debug: false,
  gaOptions: {
    anonymizeIp: true,
  },
});

initSentry();

// The other build info statements are in settings/index, but it
// doesn’t have access to React and it seems silly to include it.
if (NODE_ENV === 'development') console.log(`React Version: ${React.version}`);

const store = configureStore();

render(
  <Provider store={store}>
    <BrowserRouter>
      <ErrorBoundary>
        <Routes />
      </ErrorBoundary>
    </BrowserRouter>
  </Provider>,
  document.getElementById('app')
);
